import {
    NextStepFlowTypes,
    RECEIVE_NEXT_STEP_FLOW,
    REQUEST_NEXT_STEP_FLOW,
    REMOVE_NEXT_STEP,
    RECEIVE_LETS_GET_STARTED_FLOW,
    REQUEST_LETS_GET_STARTED_FLOW,
    UPDATE_GETSTARTED_UPDATE_STATUS,
    COMPLETE_GET_STARTED_FLOW,
    HIDE_GET_STARTED_ON_CURRENT_SESSION,
} from "./types";
import { AppThunkAction } from "..";
import * as services from "../service";

export const actionCreators = {
    requestNextStepFlow: (): AppThunkAction<NextStepFlowTypes> => (dispatch) => {
        services
            .getUserNextSteps()
            .then((data) => {
                if (!data["hasError"]) {
                    dispatch({ type: RECEIVE_NEXT_STEP_FLOW, flows: data["flows"] });
                }
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_NEXT_STEP_FLOW, flows: [] });
            });

        dispatch({ type: REQUEST_NEXT_STEP_FLOW });
    },
    requestLetsGetStartedFlow: (): AppThunkAction<NextStepFlowTypes> => (dispatch) => {
        services
            .getUserLetsgetStartedFlows()
            .then((data) => {
                if (!data["hasError"]) {
                    dispatch({ type: RECEIVE_LETS_GET_STARTED_FLOW, userLetsGetStartedFlows: data["flows"] });
                }
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_LETS_GET_STARTED_FLOW, userLetsGetStartedFlows: [] });
            });

        dispatch({ type: REQUEST_LETS_GET_STARTED_FLOW });
    },
    dismissAllItem:
        (flowType: string): AppThunkAction<NextStepFlowTypes> =>
        (dispatch) => {
            dispatch({ type: RECEIVE_LETS_GET_STARTED_FLOW, userLetsGetStartedFlows: [] });
            dispatch({ type: HIDE_GET_STARTED_ON_CURRENT_SESSION });

            services
                .dismissAllItemsByFlowType(flowType)
                .then((data) => {
                    if (data) {
                        dispatch({ type: RECEIVE_LETS_GET_STARTED_FLOW, userLetsGetStartedFlows: [] });
                    }
                })
                .catch(function (error) {
                    dispatch({ type: RECEIVE_LETS_GET_STARTED_FLOW, userLetsGetStartedFlows: [] });
                });
        },
    removeNextStep:
        (flowName: string): AppThunkAction<NextStepFlowTypes> =>
        (dispatch) => {
            dispatch({ type: REMOVE_NEXT_STEP, flowName: flowName });
        },
    updateGetStartedUpdateStatus: (): AppThunkAction<NextStepFlowTypes> => (dispatch) => {
        dispatch({ type: UPDATE_GETSTARTED_UPDATE_STATUS });
    },
    completeGetStartedItem:
        (flowID: any, flowName: string): AppThunkAction<NextStepFlowTypes> =>
        (dispatch) => {
            dispatch({ type: COMPLETE_GET_STARTED_FLOW, flowID: flowID });

            const requestBody = {
                id: flowID,
                name: flowName, //Can leave this field as empty
                status: "COMPLETED",
            };

            services.updateUserStepItem(requestBody).then((data) => {});
        },
};
